angular.module('app.rokuConnect.rokuConnectService', [])
    .factory('app.rokuConnect.rokuConnectService', [
        '$http',
        function ($http) {
            return {
                validatePin: function (pin) {
                    return $http.put(window.location.api('roku'), {pin: pin});
                }
            };
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/rokuConnect/rokuConnectService.js